export default {
  route: {
    from: {},
    to: {},
    dates: null,
  },
  query: {
    totalChildren: [],
    adults: 1,
    children: 0,
    infants: 0,
  },
};
